export const jsonHighchart = (listColumn, listLine, listSerieX, tittle, titleColumn, tittleLine,prefixColumn, prefixLine, listColor, markName) => {
    var navigator=false
    if(listSerieX.length>6){
        navigator=true
    }
    var jsonHighchart={
        chart: {
            zoomType: 'xy'
        },
        title: {
            text: tittle
        },
        subtitle: {
            text: ''
        },
        navigator: {
            enabled: navigator,
            xAxis: {
                labels: {
                    formatter: function() {
                         return listSerieX[this.pos]
                     }
                }
            }
        },
        xAxis: [{
            categories: listSerieX,
            crosshair: true,
            labels: {
                rotation: -45,
                formatter: function () {
                    if (markName === this.value) {
                        return '<span style="fill: blue;">' + this.value + '</span>';
                    } else {
                        return this.value;
                    }
                }
            },
        }],
        yAxis: [{ // Primary yAxis
            labels: {
                format: '{value}'+prefixLine,
                
            },
            title: {
                text: tittleLine,
                
            }
        }, { // Secondary yAxis
            title: {
                text: titleColumn,
                
            },
            labels: {
                format: '{value} '+prefixColumn,
                
            },
            opposite: true
        }],
        tooltip: {
            shared: true
        },
        legend: {
            layout: 'horizontal',
            align: 'left',
            x: 120,
            verticalAlign: 'top',
            y: 10,
            floating: true,
        },
        colors: listColor,
        plotOptions: {
            column: {
                dataLabels: {
                    enabled: true,
                    inside: true
                }
            },
        },
        credits: {
            enabled: false
          },
        series: [{
            name: titleColumn,
            type: 'column',
            yAxis: 1,
            data: listColumn,
            tooltip: {
                valueSuffix: prefixColumn
            },
            showInNavigator: true,
            navigatorOptions: {
                type: 'column'
            },
            legendColor:"#41B900",
            colorByPoint: true,
    
        }, {
            name: tittleLine,
            type: 'spline',
            data: listLine,
            color:"#C2272D",
            legendColor:"#C2272D",
            tooltip: {
                valueSuffix: prefixLine
            },
            showInNavigator: true,
            navigatorOptions: {
                type: 'line'
            }
        }]
    }
    return jsonHighchart
}